/* eslint-disable react-hooks/exhaustive-deps */
import React, { useEffect } from 'react';
import PropTypes from 'prop-types';
import { Row, Col, Button } from 'reactstrap';
import { useWorkFlow, LOCK_BUTTON } from "../../../contexts/workflow";
import { _Security, _translate } from "../../../../services/core";
import useActionsTypes from "../../actions-types.hook";
import Loader from "../../../common/loader";
var Connect = function Connect(props) {
  var _useWorkFlow = useWorkFlow(),
    dispatcher = _useWorkFlow.dispatcher;
  var _useActionsTypes = useActionsTypes(),
    event = _useActionsTypes.event,
    loaded = _useActionsTypes.loaded;
  var Login = props.login;
  useEffect(function () {
    if (!loaded) {
      return;
    }
    if (_Security.isAuthenticated()) {
      event.change();
      return;
    }
    dispatcher({
      type: LOCK_BUTTON,
      value: true
    });
  }, [loaded]);
  if (!loaded) {
    return /*#__PURE__*/React.createElement(Loader, null);
  }
  return /*#__PURE__*/React.createElement(Row, null, /*#__PURE__*/React.createElement(Col, {
    className: "col-6 border-right text-left d-flex align-items-end justify-content-start pr-3",
    style: {
      flexDirection: 'column'
    }
  }, /*#__PURE__*/React.createElement("div", {
    className: "d-none d-md-block"
  }, /*#__PURE__*/React.createElement("h3", {
    className: "text-left mb-4"
  }, _translate('collectorapp_not_user_space')), /*#__PURE__*/React.createElement("p", {
    className: "text-left"
  }, " ", _translate('collectorapp_not_user_space_description')), /*#__PURE__*/React.createElement("div", {
    className: "w-100 d-flex align-items-center justify-content-center"
  }, /*#__PURE__*/React.createElement(Button, {
    className: "btn-wever",
    onClick: function onClick() {
      return event.change();
    }
  }, _translate('collectorapp_start_diagnostic'))))), /*#__PURE__*/React.createElement(Col, {
    className: "col-md-6 col-12"
  }, /*#__PURE__*/React.createElement("div", {
    className: "w-100 d-md-none"
  }, /*#__PURE__*/React.createElement("div", {
    className: "w-100 d-flex align-items-center justify-content-center",
    style: {
      flexDirection: 'column'
    }
  }, /*#__PURE__*/React.createElement(Button, {
    className: "btn-wever",
    onClick: function onClick() {
      return event.change();
    }
  }, _translate('collectorapp_start_diagnostic')), /*#__PURE__*/React.createElement("div", {
    className: "my-2"
  }, /*#__PURE__*/React.createElement(React.Fragment, null, "--------- ", _translate('app_or'), " --------- ")))), /*#__PURE__*/React.createElement("h3", {
    className: "mb-4"
  }, _translate('collectorapp_have_account')), /*#__PURE__*/React.createElement(Login, {
    event: event
  })));
};
Connect.propTypes = {
  onChange: PropTypes.func.isRequired,
  elements: PropTypes.arrayOf(PropTypes.shape({})),
  index: PropTypes.number
};
Connect.defaultProps = {
  elements: [],
  index: null
};
export default Connect;